import React from 'react';

import SprintListItem from '../sprint/ListItem/insurance';
import BypassedListItem from '../bypassed/ListItem/insurance';
import QuickListItem from '../quick/ListItem/insurance';
import Box from 'common/Box';

export const InsuranceSubscriptionList = ({ sprintSubs, bypassedSubs, quickSubs, onSprintClick, onBypassedClick, onQuickClick }) => {
  if (!sprintSubs && !bypassedSubs) { return null; }

  return (
    <div>
      {sprintSubs.map(sub => (
        <Box key={sub.id}>
          <SprintListItem subscription={sub} onClick={onSprintClick} />
        </Box>
      ))}
      {bypassedSubs.map(sub => (
        <Box key={sub.id}>
          <BypassedListItem subscription={sub} onClick={onBypassedClick} />
        </Box>
      ))}
      {quickSubs.map(sub => (
        <Box key={sub.id}>
          <QuickListItem subscription={sub} onClick={onQuickClick} />
        </Box>
      ))}
    </div>
  )
}

export default InsuranceSubscriptionList;
